import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Select, Input } from 'antd';

// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';

const { Option } = Select;

export default class OrgDescription extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onMultiSelectOrganization: PropTypes.func.isRequired,
    organization: PropTypes.any.isRequired,
    industryAssociationsList: PropTypes.any.isRequired,
    naicsFoundryCodesList: PropTypes.any.isRequired,
    naicsCastingCodesList: PropTypes.any.isRequired,
    naicsMachineCodesList: PropTypes.any.isRequired,
    naicsForgingCodesList: PropTypes.any.isRequired,
    industryTypesList: PropTypes.any.isRequired,
    reasonRegistration: PropTypes.string.isRequired,
    cage: PropTypes.string.isRequired,
  };


  render() {
    const {
      onSubmit,
      onCancel,
      onChange,
      onMultiSelectOrganization,
      organization,
      industryAssociationsList,
      naicsFoundryCodesList,
      naicsCastingCodesList,
      naicsMachineCodesList,
      naicsForgingCodesList,
      industryTypesList,
      reasonRegistration,
      cage,
    } = this.props;

    const industryTypesOptions = industryTypesList.map(industryType => <Option value={industryType} label={industryType} key={industryType} id={industryType}>{industryType}</Option>);
    let foundryOptions = [];
    if (organization.industryType) foundryOptions = organization.industryType.includes("Foundry") && Object.keys(naicsFoundryCodesList).map(code => <Option value={code} label={code} key={code}>{code} - {naicsFoundryCodesList[code]}</Option>);
    let castingOptions = [];
    if (organization.industryType) castingOptions = organization.industryType.includes("Casting") && Object.keys(naicsCastingCodesList).map(code => <Option value={code} label={code} key={code}>{code} - {naicsCastingCodesList[code]}</Option>);
    let machineShopOptions = [];
    if (organization.industryType) machineShopOptions = organization.industryType.includes("Machine Shop") ? Object.keys(naicsMachineCodesList).map(code => <Option value={code} label={code} key={code}>{code} - {naicsMachineCodesList[code]}</Option>) : [];
    let forgingOptions = [];
    if (organization.industryType) forgingOptions = organization.industryType.includes("Forging") ? Object.keys(naicsForgingCodesList).map(code => <Option value={code} label={code} key={code}>{code} - {naicsForgingCodesList[code]}</Option>) : [];
    const industryAssociationOptions = industryAssociationsList.map(association => <Option value={association.sponsorAbrv} label={association.sponsorAbrv} key={association.sponsorAbrv}>{association.sponsorAbrv} - {association.sponsorName}</Option>);

    return (
      <div>
        <Row
          style={{
            flexWrap: 'nowrap',
          }}
        >
          <Col
            style={{
              marginTop: '16px',
            }}
          >
            {/* <!-- LOADING --> */}
            {/* <!-- CONTENT --> */}
            <div className="nf-registration__content">
              <Row className="nf-row--justify-end" />{' '}
              {/* <!-- USERS GRID --> */}
              <div className="nf-registration__layout">
                <div>Industry Type (Select all that apply)*</div>
                <div className="nf-registration__input" id="industryTypesSelect">
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select all that apply"
                    onChange={newValue => {
                      onMultiSelectOrganization("industryType", newValue);
                    }}
                    optionLabelProp="label"
                    value={organization.industryType}
                    disabled={cage}
                  >
                    {industryTypesOptions}
                  </Select>

                </div>
                <div className="nf-registration__input">

                  <Input
                    onChange={onChange}
                    id="reasonRegistration"
                    name="reasonRegistration"
                    type="text"
                    placeholder="Reason for registering in ICON"
                    style={{ marginRight: '10px', marginLeft: '10px', display: "none" }}
                    value={reasonRegistration}

                  />
                </div>
                <div>NAICS Codes (Select all that apply)</div>
                <div className="nf-registration__input">
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select all that apply"
                    onChange={newValue => {
                      onMultiSelectOrganization("naics", newValue);
                    }}
                    optionLabelProp="label"
                    defaultValue={organization.naics}
                    disabled={cage}
                  >
                    {foundryOptions}
                    {castingOptions}
                    {machineShopOptions}
                    {forgingOptions}
                  </Select>

                </div>
                <div>Industry Association Memberships (Select all that apply)</div>
                <div className="nf-registration__input">
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select all that apply"
                    onChange={newValue => {
                      onMultiSelectOrganization("industryAssociations", newValue);
                    }}
                    optionLabelProp="label"
                    defaultValue={organization.industryAssociations}
                  >
                    {industryAssociationOptions}
                  </Select>

                </div>
                <div className="nf-registration--wrapper">
                  <div className="nf-registration__buttons">
                    <NFButton
                      className="nf-button--gray-border"
                      style={{
                        marginRight: '16px',
                      }}
                      onClick={() => {
                        onCancel("orgStep");
                      }}
                    >
                      {msgs.Form.backButton}
                    </NFButton>
                    <NFButton
                      className="nf-button--form nf-button--orange"
                      disabled={!organization.industryType || organization.industryType.length === 0}
                      type="submit"
                      onClick={() => {
                        onSubmit();
                      }}
                    >
                      {msgs.Form.continueButton}
                    </NFButton>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/OrgDescription/OrgDescription.jsx